// Dubai - AC repair.
const content = {
    slug: 'ac-repair',
    title: (c) => `AC Repair Dubai | Diagnosis Visit ${c.money(c.tables.repairDiagnosis)}, Quote First`,
    description: (c) =>
        `AC repair in Dubai for split and ducted units. Diagnosis visit ${c.money(c.tables.repairDiagnosis)}; the technician quotes the repair before any work starts.`,
    eyebrow: 'Dubai · AC repair',
    h1: 'AC Repair in Dubai',
    lead: (c) =>
        `Not cooling, not starting, leaking or tripping the breaker - book a diagnosis visit for ${c.money(c.tables.repairDiagnosis)}. The technician finds the fault, tells you what it will cost to fix, and only starts once you agree.`,
    image: 'blog/living/broken-aircon.png',
    imageAlt: 'Faulty AC unit being diagnosed by a technician',
    facts: ['Fixed-price diagnosis', 'Quote before repair', 'Split, ducted and cassette'],
    priceTitle: 'Book a repair diagnosis',
    priceIntro: 'Pick the closest description of the problem. It helps the technician bring the right parts.',
    panel: {
        type: 'repair',
        problems: ['Not cooling', 'Water leaking', 'Not turning on', 'Noisy', 'Trips the breaker', 'Not sure'],
    },
    sections: [
        {
            title: 'Common AC faults in Dubai, and what usually fixes them',
            cards: [
                { title: 'Capacitor failure', body: 'The most common summer breakdown. Heat ages start and run capacitors; the outdoor fan or compressor hums but will not start. A quick part swap.' },
                { title: 'Blocked drain', body: 'Water dripping from the ceiling grille or the indoor unit. Dust and slime block the condensate line. Usually cleared on the spot.' },
                { title: 'Refrigerant leak', body: 'Ice on the pipes, hissing, or cool-not-cold air. The leak is found and repaired, then the gas refilled.' },
                { title: 'Thermostat or sensor', body: 'The unit stops early or runs forever. Common on older wall controllers and after power cuts.' },
                { title: 'Fan motor wear', body: 'Grinding or rattling, and weak airflow. Blower and outdoor fan motors work hard here and wear out.' },
                { title: 'PCB damage', body: 'The unit is dead or shows an error code. Power surges and heat damage control boards; replacement boards are quoted separately.' },
            ],
        },
        {
            title: 'Who pays for the repair?',
            tone: 'muted',
            paragraphs: [
                'In rented homes, major AC repairs - compressors, motors, boards, leaks - are usually the landlord\'s responsibility, while routine cleaning is often the tenant\'s. It depends on your tenancy contract. If the landlord is paying, the diagnosis report from our technician gives them the fault and the quote in writing.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is an AC repair in Dubai?',
            answer: (c) => `The diagnosis visit costs ${c.money(c.tables.repairDiagnosis)}. The repair itself depends on the fault and parts; the technician quotes it before starting, and you can decline.`,
        },
        {
            question: 'Do you carry spare parts?',
            answer: 'Technicians carry common parts like capacitors, contactors and drain fittings. Brand-specific boards and motors are ordered and fitted on a second visit.',
        },
        {
            question: 'My AC shows an error code - what does it mean?',
            answer: 'Error codes are brand-specific. Note the code and the brand when you book - it helps the technician arrive with the right part.',
        },
        {
            question: 'Can you repair my district-cooled unit?',
            answer: 'We repair the fan coil unit inside your apartment - fan motor, thermostat, valve actuator and drain. Problems with the building\'s chilled-water supply go to building management.',
        },
    ],
    schema: {
        name: 'AC Repair in Dubai',
        serviceType: 'Air conditioner repair',
        offers: (c) => [{ name: 'AC repair diagnosis visit', price: c.tables.repairDiagnosis }],
    },
}

export default content
